
export default {
    name: 'Location',

    props: {
        title: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: '',
        },
        image: {
            type: [String, Number],
            default: '',
        },
    },
};
